import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CurrentSessionService } from 'src/app/shared/services/current-session.service';
import { Report } from '../../report';
import { FetchBussinesService } from '../../services/fetch-bussines.service';
import { SellerBanckAccountService } from './seller-banck-account.service';

@Component({
  selector: 'app-seller-bank-accounts',
  templateUrl: './seller-bank-accounts.component.html',
  styleUrls: ['./seller-bank-accounts.component.scss']
})

export class SellerBankAccountsComponent implements OnInit {
  public totalEntries!: number;
  public limit!: number;
  public sellersArray: any[] = [];
  public tableColumns: string[] = ['holder_name','type', 'english_branch_name', 'bank_name', 'name', 'account_number', 'dateFormatted'];

  public displayTableColumns = {
    bank_name: "Bank Name",
    type: 'type',
    english_branch_name: "Branch Name ",
    holder_name: "Account Name",
    name: "Account owner name",
    account_number: "Account number ",
    dateFormatted: "Created at",
  };

  public accountsReportData: any[] = [];
  public totalNumberOfRecords = 0;
  public requestBody: Report = {};
  loading = false;
  assignedSellersArray: any[];
  adminName: string = ''
  isAssignedBusinessSelected: boolean = false;

  constructor(
    public sellerBankAccountService: SellerBanckAccountService,
    public fetchBussines: FetchBussinesService,
    private auth:AuthService,
    private getCurrentSessionService: CurrentSessionService,
  ) { }

  async ngOnInit() {
    this.adminName = (await this.auth.getRole()).name
    this.isAssignedBusinessSelected = this.adminName.includes('SuperAdmin') ? false : true;
    this.sellerBankAccountService.activateLoader();
    let response = await this.fetchBussines.make();
    this.sellersArray = response.result;
    const adminId =(await this.getCurrentSessionService.make())?.data?.userId;
    this.assignedSellersArray = this.sellersArray.filter(seller => seller.adminId == adminId)
    console.log(this.assignedSellersArray)
  }

  async updateTable() {
    this.sellerBankAccountService.activateLoader();
    this.sellerBankAccountService.setParams(this.requestBody);
    const report = await this.sellerBankAccountService.make();
    this.accountsReportData = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.sellerBankAccountService.loader().subscribe(val => (this.loading = val));
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.sellerBankAccountService.loader().subscribe(val => (this.loading = val));
  }

  async searchChance(event: string) {
    if (event) {
      this.requestBody.searchOptions = { searchKey: event };
    } else {
      this.requestBody.searchOptions = undefined;
      this.sellerBankAccountService.loader().subscribe(val => (this.loading = val));
    }
    await this.updateTable();
  }

  async displaySeller(event: any) {
      this.requestBody.filterOptions = { BusinessId: event };
      await this.updateTable();
      this.sellerBankAccountService.loader().subscribe(val => (this.loading = val));
  }

  checkboxChange(){

  }

  async sortChange(event: any) {
    if (event.direction === "") {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.sellerBankAccountService.loader().subscribe(val => (this.loading = val));
  }

}
